import styled from 'styled-components'
import { Color } from '../../styles/color'

const TableHeaderRow = styled.tr`
    border-bottom: 1px solid ${Color.blue2};
`

export default TableHeaderRow